<div class="filtered-table-container">
  <rr-progressbar *ngIf="showProgressBar" [model]="progressBarModel">
  </rr-progressbar>
  <rr-table-filters-container
    *ngIf="filterContainerSettings"
    [filterContainerModel]="filterContainerSettings"
    (changedFilter)="onFiltersChange($event)"
    (submit)="onFiltersSubmit($event)"
    (dropdownFilterClicked)="onDropFilterClicked($event)"
  ></rr-table-filters-container>
  <ng-content></ng-content>
  <rr-table-container
    *ngIf="tableContainerSettings"
    [spinnerStatus]="spinnerStatus"
    [model]="tableContainerSettings"
    [addButtonLeft]="addButtonLeft"
    [addButtonRight]="addButtonRight"
    [selectedRows]="selectedRows"
    [selectedRadioEntity]="selectedRadioEntity"
    [clearRadioSelection]="clearRadioSelection"
    (paginationChange)="onPaginationChange($event)"
    (sortBy)="onSortBy($event)"
    (actionClicked)="onActionClicked($event)"
    (actionConfirmed)="onActionConfirmed($event)"
    (batchOptionClicked)="onBatchOptionClicked($event)"
    (batchOptionConfirmed)="onBatchOptionConfirmed($event)"
    (rowSelected)="onRowSelected($event)"
    (rowClicked)="onRowClicked($event)"
    (changeVisableColumns)="onChangeVisableColumns($event)"
    (radioSelected)="onRadioSelected($event)"
    (radioSelectionCleared)="onRadioSelectionCleared()"
    (selectAllClicked)="onSelectAllClicked()"
  ></rr-table-container>
</div>
